import { Card, Elevation } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { PersonDto } from "../../../api";

export interface IDrupalPersonInfoCardProps {
  person: PersonDto;
  title: string;
}
const MainContainer = styled(Card)`
  width: 25rem;
  height: 10rem;
  background-color: #0091ff;
  padding: 0px;
  margin: 1.5rem;
`;

const Container = styled.div`
  height: 10rem;
  width: 24.5rem;
  margin-left: 0.5rem;
  background-color: #ffffff;
  border-radius: 3px;
`;

export const DrupalPersonInfoCard: React.FunctionComponent<IDrupalPersonInfoCardProps> = ({ person, title }) => {
  return (
    <MainContainer elevation={Elevation.THREE}>
      <Container>
        <h2 style={{ fontSize: "25px", marginLeft: "3rem", marginBottom: "0.5rem" }}>{title}</h2>
        {person.computedName && (
          <div style={{ marginLeft: "4rem", marginBottom: "1rem" }}>
            <i className="fas fa-user" style={{ marginRight: "0.5rem", color: "#8a8a8a" }} />
            {person.computedName}
          </div>
        )}

        {person.email && (
          <div style={{ marginLeft: "4rem", marginBottom: "1rem" }}>
            <i className="fas fa-at" style={{ marginRight: "0.5rem", color: "#8a8a8a" }} />
            {person.email}
          </div>
        )}
        {person.mobilePhoneNumber && !person.phoneNumber && (
          <div style={{ marginLeft: "4rem", marginBottom: "1rem" }}>
            <i className="fas fa-mobile-alt" style={{ marginRight: "0.5rem", color: "#8a8a8a" }} />
            {person.mobilePhoneNumber}
          </div>
        )}
        {person.phoneNumber && !person.mobilePhoneNumber && (
          <div style={{ marginLeft: "4rem", marginBottom: "0.5rem" }}>
            <i className="fas fa-phone-alt" style={{ marginRight: "0.5rem", color: "#8a8a8a" }} />
            {person.phoneNumber}
          </div>
        )}
        {person.phoneNumber && person.mobilePhoneNumber && (
          <div style={{ marginLeft: "4rem", marginBottom: "0.5rem" }}>
            <i className="fas fa-mobile-alt" style={{ marginRight: "0.5rem", color: "#8a8a8a" }} />
            {person.mobilePhoneNumber}
            <i className="fas fa-phone-alt" style={{ marginRight: "0.5rem", marginLeft: "0.8rem", color: "#8a8a8a" }} />
            {person.phoneNumber}
          </div>
        )}
      </Container>
    </MainContainer>
  );
};
